import { Platform, StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { Screen } from "../../../../shared/types";
import { getCurrentScreenSize } from "../../../../shared/util/screen";

const IMAGE_ASPECT_RATIO = 4 / 5;

const IMAGE_SIZES_PER_BREAKPOINT = {
  XL: 800,
  L: 600,
  M: 400,
  S: 300,
};

interface ExtendedScreen extends Screen {
  readonly XL: boolean;
}

const getImageWidthInPixels = (screen: ExtendedScreen) => {
  const breakpoint = screen.XL ? "XL" : getCurrentScreenSize(screen);
  const imageSize = IMAGE_SIZES_PER_BREAKPOINT[breakpoint];

  return imageSize;
};

const style = () => {
  const {
    borderRadiusFull,
    colorBgPrimaryMediumLight,
    colorTextActionPrimary,
    colorBgOpacity,
    space05,
    space1,
    space2,
    space3,
    space4,
    space6,
    space8,
  } = theme();

  return StyleSheet.create({
    button: {
      alignItems: "center",
      backgroundColor: colorBgOpacity,
      borderRadius: borderRadiusFull,
      bottom: space4,
      display: "flex",
      flexDirection: "row",
      paddingHorizontal: space3,
      paddingVertical: space1,
      position: "absolute",
      right: space6,
      ...Platform.select({
        native: {
          borderRadius: space6,
          paddingVertical: space05,
          height: space8,
        },
      }),
    },
    buttonText: {
      color: colorTextActionPrimary,
      marginRight: space1,
    },
    image: {
      flex: 1,
    },
    imageCta: {
      height: "100%",
      marginBottom: space2,
      width: "100%",
    },
    imageLoaded: {
      opacity: 1,
      ...Platform.select({
        web: {
          transition: "opacity 1s ease-out",
        },
      }),
    },
    imageNotLoaded: {
      opacity: 0,
    },
    imagePressable: {
      flex: 1,
      width: "100%",
    },
    itemContent: {
      aspectRatio: IMAGE_ASPECT_RATIO,
      backgroundColor: colorBgPrimaryMediumLight,
    },
    itemWrapper: {
      paddingBottom: space05,
      paddingRight: space05,
    },
    sliderWrapper: {
      marginBottom: space6,
      width: "100%",
    },
    wrapper: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      width: "100%",
    },
  });
};

export { style, getImageWidthInPixels };
